import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';

export const Cart: React.FC = () => {
    return (
        <>
            <Helmet>
                <title>Your Cart — ForexFundAI Institutional Access</title>
                <meta name="description" content="View your selected institutional trading plans. Complete your subscription to unlock AI fundamental analysis, real-time signals, and MT5 autotrade." />
                <meta name="robots" content="noindex, follow" />
            </Helmet>
        <div className="min-h-screen bg-finance-darker py-24 px-4 sm:px-6 flex flex-col items-center">
            <div className="w-full max-w-lg bg-finance-card border border-gray-800 rounded-2xl p-8 text-center shadow-2xl">
                <div className="w-20 h-20 bg-finance-accent/10 rounded-full flex items-center justify-center mx-auto mb-6">
                    <ShoppingCart className="w-10 h-10 text-finance-accent" />
                </div>
                <h2 className="text-3xl font-bold text-white mb-4">Your Cart</h2>
                <p className="text-gray-400 mb-8 leading-relaxed">
                    Stripe checkout integration will be implemented here. For now, this is a placeholder for the cart page.
                </p>
                <Link to="/dashboard" className="inline-block bg-finance-accent hover:bg-yellow-500 text-finance-dark font-bold px-8 py-4 rounded-xl transition-all shadow-lg shadow-finance-accent/20 w-full">
                    Return to Dashboard
                </Link>
            </div>
        </div>
        </>
    );
};
